import { useEffect, useState } from "react";
import { auth } from "../firebase/auth";
import { db } from "../firebase/firestore";
import { doc, onSnapshot } from "firebase/firestore";

export function useCurrentUser() {
  const [displayName, setDisplayName] = useState<string>("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const currentUser = auth.currentUser;
    const phone = currentUser?.phoneNumber;

    if (!phone) {
      setLoading(false);
      return;
    }

    const ref = doc(db, "users", phone);

    const unsub = onSnapshot(ref, (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setDisplayName(data.str || "");
      }
      setLoading(false);
    });

    return () => unsub();
  }, []);

  return { displayName, loading };
}